import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { TranslateService } from '@ngx-translate/core';

import 'rxjs/add/observable/of';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/delay';
import 'rxjs/add/operator/catch';

import { environment } from '../../environments/environment';

@Injectable()
export class GlobalService {


  constructor(
    private http: HttpClient,
    private toastr: ToastsManager,
    private translate: TranslateService,
    private router: Router) {
  }

  headers = new HttpHeaders().set('Content-Type', 'application/json');

  UrlPortalLogin = environment.LoginURL + "login/" +
                   environment.Ambiente.toString() + "/" +
                   environment.AppToken;


  getToken() {
    return localStorage.getItem('key');
  }

  public urlContaE() {
    return document.getElementsByTagName('base')[0].href;
  }

  public verifyResponse(response) {

    if (response.Result) {
      return true;
    } else {
      if (response.Codigo === 0) {
        this.redirectWeb();
      } else if (response.Codigo < 0) {
        if (response.Codigo === -1 || response.Codigo === -2) {
          this.toastr.error(response.Message, 'Error!', { toastLife: 10000, showCloseButton: true });
        } else if (response.Codigo === -3) {
          this.toastr.warning(response.Message, 'Alert!', { toastLife: 10000, showCloseButton: true });
        } else {

            this.translate.get('ERROR.' + response.Message).subscribe((res: string) => {
            this.toastr.error(res, 'Error!', { toastLife: 10000, showCloseButton: true });

          });
        }
        return false;
      } else {
        return true;
      }
    }
  }

  public verifyResponseSSO(response) {

    if (response.result) {
      return true;
    } else {
      if (response.code === 0) {
        this.redirectWeb();
      } else if (response.Codigo < 0) {
        if (response.code === -1 || response.code === -2) {
          this.toastr.error(response.message, 'Error!', { toastLife: 10000, showCloseButton: true });
        } else if (response.Codigo === -3) {
          this.toastr.warning(response.message, 'Alert!', { toastLife: 10000, showCloseButton: true });
        } else {

            this.translate.get('ERROR.' + response.message).subscribe((res: string) => {
            this.toastr.error(res, 'Error!', { toastLife: 10000, showCloseButton: true });

          });
        }
        return false;
      } else {
        return true;
      }
    }
  }

  private redirectWeb() {
    this.toastr.info('Su sesión ha expirado, sera redireccionado.');
    localStorage.setItem('key', '');
    localStorage.setItem('jwt', '');
    const redirect = '/authentication/login';
    this.router.navigate([redirect]);
  }
  public async redirectWeb_SSO() {

    let message = 'Su sesión ha expirado, será redireccionado en unos segundos. Favor de Iniciar sesión de nuevo';
    this.toastr.info(message);
    await new Promise(f => setTimeout(f, 3500));//Delay 3.5 seconds to show the message to the user
    localStorage.setItem('key', '');
    localStorage.setItem('jwt', '');
    window.location.href = this.UrlPortalLogin;

  }

  private sessionStatus(): Observable<any> {
    const obj = {
      UserToken: this.getToken()
    };
    const json = JSON.stringify(obj);
    return this.http.post<any>(this.urlContaE() + 'Home/IsActiveSession', json, { headers: this.headers })
      .catch(error => {
        return Observable.throw('An error occurred:', error.message);
      });
  }

  public verifySession() {
    this.sessionStatus().subscribe(resp => {
      if (resp.Result) {
        return true;
      } else {
        this.redirectWeb();
      }
    });
  }



}



// WEBPACK FOOTER //
// ./src/app/global/global.service.ts